module.exports = __webpack_public_path__ + "static/media/education1.c3f359df.jpg";